package com.fireavert.gateways.gateway_dialog.client.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class GatewayImageDataResponse(
    var imageList: Map<Int, String>
)